import  "./footer.scss"
import logo from "../../logo.png"
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import { Link as ScrollLink } from "react-scroll";
import { Link } from "react-router-dom";
import phone from "../../assets/images/phone.svg"
import email from "../../assets/images/email.svg"
import location from "../../assets/images/location.svg"
import facebook from "../../assets/images/facebook.svg"
import insta from "../../assets/images/insta.svg"
import LinkedIn from "../../assets/images/LinkedIn.svg"
import youtube from "../../assets/images/youtube.svg"
import heart from "../../assets/images/heart.svg"

export default function Footer() {
  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: true
    });
  }, []);
  return(
    <>
      <footer className="footer_wrapper" data-aos="fade-in">
        <div className="container">
          <div className="news_letter">
            <div className="shape_one"></div>
            <div className="shape_one shape_two"></div>
            <h2>Subscribe to our newsletter</h2>
            <p>Stay updated with our latest newsletter release.</p>
            <form>
              <input type="email" placeholder="Email Address"/>
              <button className="simple_btn">Subscribe</button>
            </form>
          </div>
          <div className="footerlogo">
            <ScrollLink
              to="home"
              spy={true}
              smooth={true}
            >
              <img src={logo} alt="logo" />
            </ScrollLink>
            <ul className="list-none social_info flex items-center">
              <li><Link to="https://www.instagram.com/deusyachting/" target="_blank"><img src={insta} alt="insta"/></Link></li>
            </ul>
            <div className="contact_info_footer">
              <ul className="list-none contact_info">
                <li><span><img src={phone} alt="phone"/></span><Link to="tel:+1-876-431-0549">+1-876-431-0549</Link></li>
                <li><span><img src={email} alt="email"/></span><Link to="mailto:deuscharters@outlook.com">deuscharters@outlook.com</Link></li>
                <li><span><img src={location} alt="location"/></span><Link to="https://maps.app.goo.gl/A88E5jCiTpiGoYcy9" target="_blank">The monetgo bay yacht club, montego bay, st James parish, Jamaica</Link></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="footer_bottom_area">
          <div className="container">
            <span>Copyrights © 2025 All Rights Reserved.</span>
            <span>Developed with <img src={heart} alt="heart"/> by <Link to="https://www.softenica.com/" target="_blank">Softenica Technologies</Link></span>
          </div>
        </div>
      </footer>
    </>
  )
}

